import React, { Component } from "react";
const Like = (props) => {
  let classes = "fa fa-heart-o text-danger";
  if (!props.liked) classes = "fa fa-heart-o";
  return <i className={classes} onClick={props.onClick} aria-hidden="true"></i>;
};

export default Like;
